// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/billing/v1/vision_billing.proto (package protos.vision.billing.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/billing/v1/vision_billing.proto.
 */
export const file_vision_billing_v1_vision_billing: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.billing.v1.SubscriptionPlan
 */
export type SubscriptionPlan = Message<"protos.vision.billing.v1.SubscriptionPlan"> & {
  /**
   * @generated from field: string plan_key = 1;
   */
  planKey: string;

  /**
   * @generated from field: protos.vision.billing.v1.SubscriptionTier tier = 2;
   */
  tier: SubscriptionTier;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string price_label = 4;
   */
  priceLabel: string;

  /**
   * @generated from field: int64 subscription_credits = 5;
   */
  subscriptionCredits: bigint;

  /**
   * @generated from field: int64 storage_limit_bytes = 6;
   */
  storageLimitBytes: bigint;

  /**
   * @generated from field: int32 sort_order = 7;
   */
  sortOrder: number;
};

/**
 * Describes the message protos.vision.billing.v1.SubscriptionPlan.
 * Use `create(SubscriptionPlanSchema)` to create a new message.
 */
export const SubscriptionPlanSchema: GenMessage<SubscriptionPlan> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_vision_billing, 0);

/**
 * @generated from message protos.vision.billing.v1.CreditPack
 */
export type CreditPack = Message<"protos.vision.billing.v1.CreditPack"> & {
  /**
   * @generated from field: string pack_key = 1;
   */
  packKey: string;

  /**
   * @generated from field: string price_label = 2;
   */
  priceLabel: string;

  /**
   * @generated from field: int64 credits = 3;
   */
  credits: bigint;
};

/**
 * Describes the message protos.vision.billing.v1.CreditPack.
 * Use `create(CreditPackSchema)` to create a new message.
 */
export const CreditPackSchema: GenMessage<CreditPack> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_vision_billing, 1);

/**
 * @generated from message protos.vision.billing.v1.CreditTransaction
 */
export type CreditTransaction = Message<"protos.vision.billing.v1.CreditTransaction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: protos.vision.billing.v1.CreditTransactionType transaction_type = 2;
   */
  transactionType: CreditTransactionType;

  /**
   * @generated from field: int64 amount = 3;
   */
  amount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.billing.v1.CreditTransaction.
 * Use `create(CreditTransactionSchema)` to create a new message.
 */
export const CreditTransactionSchema: GenMessage<CreditTransaction> = /*@__PURE__*/
  messageDesc(file_vision_billing_v1_vision_billing, 2);

/**
 * @generated from enum protos.vision.billing.v1.SubscriptionStatus
 */
export enum SubscriptionStatus {
  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_CANCELING = 3;
   */
  CANCELING = 3,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_PAST_DUE = 4;
   */
  PAST_DUE = 4,

  /**
   * @generated from enum value: SUBSCRIPTION_STATUS_LAPSED = 5;
   */
  LAPSED = 5,
}

/**
 * Describes the enum protos.vision.billing.v1.SubscriptionStatus.
 */
export const SubscriptionStatusSchema: GenEnum<SubscriptionStatus> = /*@__PURE__*/
  enumDesc(file_vision_billing_v1_vision_billing, 0);

/**
 * @generated from enum protos.vision.billing.v1.SubscriptionTier
 */
export enum SubscriptionTier {
  /**
   * @generated from enum value: SUBSCRIPTION_TIER_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SUBSCRIPTION_TIER_FREE = 1;
   */
  FREE = 1,

  /**
   * @generated from enum value: SUBSCRIPTION_TIER_SMALL = 2;
   */
  SMALL = 2,

  /**
   * @generated from enum value: SUBSCRIPTION_TIER_MEDIUM = 3;
   */
  MEDIUM = 3,

  /**
   * @generated from enum value: SUBSCRIPTION_TIER_LARGE = 4;
   */
  LARGE = 4,

  /**
   * @generated from enum value: SUBSCRIPTION_TIER_STORAGE_SMALL = 5;
   */
  STORAGE_SMALL = 5,

  /**
   * @generated from enum value: SUBSCRIPTION_TIER_STORAGE_MEDIUM = 6;
   */
  STORAGE_MEDIUM = 6,

  /**
   * @generated from enum value: SUBSCRIPTION_TIER_STORAGE_LARGE = 7;
   */
  STORAGE_LARGE = 7,
}

/**
 * Describes the enum protos.vision.billing.v1.SubscriptionTier.
 */
export const SubscriptionTierSchema: GenEnum<SubscriptionTier> = /*@__PURE__*/
  enumDesc(file_vision_billing_v1_vision_billing, 1);

/**
 * @generated from enum protos.vision.billing.v1.GracePhase
 */
export enum GracePhase {
  /**
   * @generated from enum value: GRACE_PHASE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: GRACE_PHASE_NONE = 1;
   */
  NONE = 1,

  /**
   * @generated from enum value: GRACE_PHASE_WARNING = 2;
   */
  WARNING = 2,

  /**
   * @generated from enum value: GRACE_PHASE_RESTRICTED = 3;
   */
  RESTRICTED = 3,

  /**
   * @generated from enum value: GRACE_PHASE_EXPIRED = 4;
   */
  EXPIRED = 4,
}

/**
 * Describes the enum protos.vision.billing.v1.GracePhase.
 */
export const GracePhaseSchema: GenEnum<GracePhase> = /*@__PURE__*/
  enumDesc(file_vision_billing_v1_vision_billing, 2);

/**
 * The kind of ledger row in vision_credit_transactions. Only the kinds the read
 * path can surface today are modeled; an unmapped stored value reads as UNKNOWN.
 *
 * @generated from enum protos.vision.billing.v1.CreditTransactionType
 */
export enum CreditTransactionType {
  /**
   * @generated from enum value: CREDIT_TRANSACTION_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CREDIT_TRANSACTION_TYPE_SUBSCRIPTION_GRANT = 1;
   */
  SUBSCRIPTION_GRANT = 1,

  /**
   * @generated from enum value: CREDIT_TRANSACTION_TYPE_PURCHASE = 2;
   */
  PURCHASE = 2,

  /**
   * @generated from enum value: CREDIT_TRANSACTION_TYPE_TRANSFER_TO_PROJECT = 3;
   */
  TRANSFER_TO_PROJECT = 3,

  /**
   * @generated from enum value: CREDIT_TRANSACTION_TYPE_PROJECT_PACK_PURCHASE = 4;
   */
  PROJECT_PACK_PURCHASE = 4,

  /**
   * @generated from enum value: CREDIT_TRANSACTION_TYPE_PROJECT_REFUND = 5;
   */
  PROJECT_REFUND = 5,
}

/**
 * Describes the enum protos.vision.billing.v1.CreditTransactionType.
 */
export const CreditTransactionTypeSchema: GenEnum<CreditTransactionType> = /*@__PURE__*/
  enumDesc(file_vision_billing_v1_vision_billing, 3);

/**
 * @generated from enum protos.vision.billing.v1.CreditSource
 */
export enum CreditSource {
  /**
   * @generated from enum value: CREDIT_SOURCE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CREDIT_SOURCE_PROJECT = 1;
   */
  PROJECT = 1,

  /**
   * @generated from enum value: CREDIT_SOURCE_PERSONAL = 2;
   */
  PERSONAL = 2,
}

/**
 * Describes the enum protos.vision.billing.v1.CreditSource.
 */
export const CreditSourceSchema: GenEnum<CreditSource> = /*@__PURE__*/
  enumDesc(file_vision_billing_v1_vision_billing, 4);

